module.exports = __webpack_public_path__ + "static/logo-7f78ec48706a69d0ced32e9bb6b355ba.png";